

















import Vue from "vue";
import { loadStripe } from "@stripe/stripe-js";
import { Computed, Data, Method, Props } from "./types";
import Locale from "@/lib/locale";
import { RollbarNotify } from "@/lib/rollbarNotify";

export default Vue.extend<Data, Method, Computed, Props>({
  name: "vc-stripe-input-form",
  props: {
    clientSecret: { default: "" },
    lang: { default: () => undefined },
    publishableKey: { default: "" },
    returnUrl: { default: "" },
    twoletterCountryCode: { default: "" }
  },
  data() {
    return {
      localeForStripe: Locale.getStripeLocale(),
      isDisabledSubmit: true,
      isShowSubmitButton: false,
      message: "",
      paymentElementOptions: {
        layout: "tabs",
        defaultValues: {
          billingDetails: {
            address: {
              country: this.twoletterCountryCode
            }
          }
        },
        fields: {
          billingDetails: {
            address: {
              country: "never"
            }
          }
        }
      },
      stripe: undefined,
      stripeElements: undefined
    };
  },
  mounted() {
    this.setupStripe();
  },
  methods: {
    async setupStripe() {
      const stripe = await loadStripe(this.publishableKey, {
        locale: this.localeForStripe
      });

      if (!stripe) throw "invalid stripe";

      this.stripe = stripe;
      const stripeElements = stripe.elements({
        clientSecret: this.clientSecret
      });
      this.stripeElements = stripeElements;
      const paymentElement = stripeElements.create(
        "payment",
        this.paymentElementOptions
      );
      paymentElement.mount("#payment-element");
      this.isShowSubmitButton = true;
      this.isDisabledSubmit = false;
    },
    async onSubmit() {
      this.isDisabledSubmit = true;
      if (!this.stripe || !this.stripeElements) throw "Invalid Submit";

      try {
        const res = await this.stripe.confirmSetup({
          elements: this.stripeElements,
          confirmParams: {
            return_url: this.returnUrl,
            payment_method_data: {
              billing_details: {
                address: {
                  country: this.twoletterCountryCode
                }
              }
            }
          }
        });

        this.notifyError(res.error);
        this.isDisabledSubmit = false;
      } catch (error) {
        RollbarNotify.error(
          `月額利用プランの支払情報変更処理中、支払情報をStripeへ送信する際に予期せぬエラーが発生しました。(Promise rejected) エラーレスポンス:  ${this.formatErrorResponse(
            error
          )}`
        );
        this.showMessage("An unexpected error occurred.");
        this.isDisabledSubmit = false;
      }
    },
    formatErrorResponse(error) {
      if (error === null) {
        return "null";
      }
      return typeof error === "object" ? JSON.stringify(error) : error;
    },
    notifyError(error) {
      if (
        error.type === "card_error" ||
        error.type === "validation_error" ||
        error.code === "setup_intent_authentication_failure"
      ) {
        this.showMessage(error.message || "undefined");
        return;
      }

      if (error.code === "setup_intent_unexpected_state") {
        RollbarNotify.error(
          `月額利用プランの支払情報変更処理中、すでにリクエスト済みの"setupIntentId"に対して再度支払情報登録リクエストを行った可能性があります。エラーレスポンス: ${JSON.stringify(
            error
          )}`
        );
        this.showMessage("An unexpected error occurred.");
        return;
      }

      RollbarNotify.error(
        `月額利用プランの支払情報変更処理中、支払情報をStripeへ送信する際にエラーが発生しました。エラーレスポンス: ${JSON.stringify(
          error
        )}`
      );
      this.showMessage("An unexpected error occurred.");
    },
    showMessage(message) {
      this.message = message;
      setTimeout(() => (this.message = ""), 5000);
    }
  }
});
